import React from 'react';
import * as I18n from 'circe/I18n';

import FormControlLabel from 'pencil/FormControlLabel';
import Checkbox from 'pencil/Checkbox';
import { Typography, Grid } from 'pencil';
import Input from 'pencil/Input';
import InputLabel from 'pencil/InputLabel';
import MenuItem from 'pencil/MenuItem';
import FormControl from 'pencil/FormControl';
import ListItemText from 'pencil/ListItemText';
import Select from 'pencil/Select';
import { ACLs } from 'domain/constants';
import { withStyles } from 'pencil/styles';
import Switch from 'pencil/Switch';
import SwitchField from 'circe/forms/fields/SwitchField';
import SelectField from 'circe/forms/fields/SelectField';
import { getAclArray } from '../utils';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
// startCase
const styles = {
  aclControl: {
    marginTop: -16,
  },
};

class FieldsAclSelection extends React.Component {
  render() {
    const { fields = [], classes } = this.props;
    return (
      <React.Fragment>
        <Typography variant="h6">{I18n.str('fields', 'Fields')}</Typography>
        <Grid container>
          <Grid item xs={3}>
            <FormControlLabel
              control={<Checkbox value="checkedB" color="primary" />}
              label="Primary"
            />
          </Grid>

          <Grid xs={3}>
            <SwitchField name="sortable" label={I18n.str('sortable', 'Sortable')} />
          </Grid>
          <Grid xs={3}>
            <SwitchField name="filterable" label={I18n.str('filterable', 'Filterable')} />
          </Grid>
          <Grid xs={3}>
            <SelectField
              label={I18n.str('perPage', 'Items Per Page')}
              fullWidth
              MenuProps={MenuProps}
              multiple
              name="perPage"
              options={getAclArray()}
              classes={{
                formControl: classes.formControl,
                label: classes.controlLabel,
              }}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(FieldsAclSelection);
